import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#i-1268106156__a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "m13.818 21.316-2.545-3.181H6.545a.91.91 0 0 1-.909-.91V7.32a.91.91 0 0 1 .91-.909H21.09a.91.91 0 0 1 .909.91v9.905a.91.91 0 0 1-.91.91h-4.726zm1.672-5h4.692V8.228H7.455v8.088h4.691l1.672 2.09zM2.91 2.68h15.454v1.818H3.818v10H2V3.59a.91.91 0 0 1 .91-.909"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "i-1268106156__a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h24v24H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }